<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
        <div class="p-col">
          <Button class="p-button p-component p-button-success addNewBtn btn-btm-0" @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" v-if="showNewButton"/>
        </div>
      </div>
      <Dialogs header="CRM Follow-up" :visible.sync="addDisplayBasic"  :style="{width: '60vw'}" 
      :closable=false
       @show="checkNepaliDateOrEnglish" >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label for="particular">Particular</label>
            <InputText id="particular" v-model.trim="particular" />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="clientName">Client Name <span style="color:red">*</span></label>
            <InputText id="clientName" v-model.trim="clientName" />
          </div>
          
          <div class="p-field p-col-12 p-md-4">
            <label for="contactPerson">Contact Person</label>
            <InputText id="contactPerson" v-model.trim="contactPerson" />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="province">Province</label>
            <Dropdown 
              id="province" 
              v-model="selectedProvince" 
              :options="provinceList" 
              optionLabel="name" 
              optionValue="name" 
              placeholder="Select Province"
              @change="updateDistrictList" 
            />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="district">District</label>
            <Dropdown 
              id="district" 
              v-model="selectedDistrict" 
              :options="filteredDistricts" 
              optionLabel="name" 
              optionValue="name" 
              placeholder="Select District" 
              :disabled="!selectedProvince"
            />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="address">Address</label>
            <InputText id="address" v-model.trim="address" />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="contactNumber">Contact Number <span style="color:red">*</span></label>
            <InputText id="contactNumber" v-model.trim="contactNumber" @input="validateContactNumber" maxlength="10"/>
          </div>
          
          <div class="p-field p-col-12 p-md-4">
            <label for="secondaryContactNumber">Secondary Contact Number</label>
            <InputText id="secondaryContactNumber" v-model.trim="secondaryContactNumber" @input="validateSeconContactNumber" maxlength="10"/>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="gmail">Email</label>
            <InputText id="gmail" v-model.trim="gmail" />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="product">Product</label>
            <MultiSelect
              id="product"
              v-model="selectedProducts"
              :options="productList"
              optionLabel="name"
              placeholder="Select Products"
              :showCheckbox="true"
              :filter="true"
              @filter="searchProducts"
              style="height: 36px !important; min-height: 36px !important;"
            >
              <template #option="slotProps">
                <div class="p-multiselect-item-option">
                  <span>{{ slotProps.option.name }}</span>
                </div>
              </template>
            </MultiSelect>
          </div>
          
          <div class="p-field p-col-12 p-md-4">
            <label for="rate">Rate</label>
            <InputText id="rate" v-model.trim="rate" />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="customerType">Customer Type<span style="color:red">*</span></label>
            <Dropdown 
              id="customerType" 
              v-model="customerType" 
              :options="filteredCustomerTypes" 
              optionLabel="label" 
              optionValue="value" 
              placeholder="Select Customer Type" 
            />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="priority">Priority</label>
            <Dropdown 
              id="priority" 
              v-model="priority" 
              :options="priorityList" 
              optionLabel="value" 
              optionValue="value" 
              placeholder="Select Priority" />
          </div>

          <div class="p-field p-col-12 p-md-4">
            <label for="stage">Stage</label>
            <Dropdown 
              id="stage" 
              v-model="selectedStage" 
              :options="stageList" 
              optionLabel="value" 
              optionValue="value" 
              placeholder="Select Stage" />
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="soldfrom">Sold From Type<span style="color:red">*</span></label>
            <Dropdown 
              id="soldfrom" 
              v-model="soldFrom" 
              :options="soldFromLists" 
              optionLabel="label" 
              optionValue="value" 
              placeholder="Select Sold From" 
            />
          </div>
          <div class="p-field p-col-12 p-md-3">
            <div class="p-field-checkbox">
              <Checkbox id="commission" v-model="commission" :binary="true" />
              <label for="commission" class="p-checkbox-label">Commission</label>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <div class="p-field-checkbox">
              <Checkbox id="sampleQuotationSent" v-model="sampleQuotationSent" :binary="true" />
              <label for="sampleQuotationSent" class="p-checkbox-label">Sample Sent</label>
            </div>
          </div>

          <div class="p-field p-col-12 p-lg-6 p-xl-2">
        <label>Sample Date</label>
        <date-picker
          ref="sam"
          v-model="sampleSentDate"
          valueType="format"
          v-if="!englishDateEnabled"
        />
        <input-mask
          mask="9999-99-99"
          ref="sam"
          v-else
          class="nepali-calendar"
          id="sampleSentDate"
          v-model="sampleSentDate"
        />
      </div>
          
          
          <div class="p-field p-col-12 p-md-2">
            <div class="p-field-checkbox">
              <Checkbox id="callNotReceived" v-model="callNotReceived" :binary="true" />
              <label for="callNotReceived" class="p-checkbox-label">Call Not Received</label>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <div class="p-field-checkbox">
              <Checkbox id="quotationSent" v-model="quotationSent" :binary="true" />
              <label for="quotationSent" class="p-checkbox-label">Quotation Sent</label>
            </div>
          </div>
          <div class="p-field p-col-12 p-lg-6 p-xl-2">
        <label>Quotation Date</label>
        <date-picker
          ref="qot"
          v-model="quotationSentDate"
          valueType="format"
          v-if="!englishDateEnabled"
        />
        <input-mask
          mask="9999-99-99"
          ref="qot"
          v-else
          class="nepali-calendar"
          id="quotationSentDate"
          v-model="quotationSentDate"
        />
        </div>
          
          
        </div>
        <template #footer>
          <Button 
            label="Manage Remarks" 
            icon="pi pi-comments" 
            class="p-button-raised" 
            @click="openRemarksDialog" 
          />
          <Button class="p-button-raised p-button" @click.prevent="addFollowUpDetails" :label="editing?'Update':'Add'"/>
          <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewFollowUpDetails" v-if="!editing"/>
          <Button @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
        </template>
      </Dialogs>
    </form>
    <RemarksDialog
      :visible.sync="remarksDialogVisible"
      :initialRemarks="{
        remarks: remarks,
        remarks1: remarks1,
        remarks2: remark2,
        followUpTime: followUpTime,
        nextFollowUpDate: nextFollowUpDate 
      }"
      @save="saveRemarks"
    />
  </div>
</template>

<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import RemarksDialog from '../crm/RemarksDialog.vue'
import MultiSelect from 'primevue/multiselect'
import InputMask from 'primevue/inputmask'
import $ from 'jquery'

export default {
  name: 'crmFollowUpDetailsDialog',
  props: {
    showNewButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clientName: '',
      englishDateEnabled: true,
      quotationSentDate: '',
      sampleSentDate: '',
      contactPerson: '',
      address: '',
      contactNumber: '',
      secondaryContactNumber: '',
      gmail: '',
      product: '',
      particular: '',
      rate: '',
      customerType: null,
      soldFrom: null,
      priority: null,
      sampleQuotationSent: null,
      quotationSent: null,
      callNotReceived: false,
      commission: false,
      selectedStage: null,
      remarks: '',
      remarks1: '',
      remark2: '',
      nextFollowUpDate: null,
      followUpTime: null,
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      id: '',
      loading: false,
      selectedProducts: [],
      productList: [],
      // Province and District data
      selectedProvince: null,
      selectedDistrict: null,
      provinceList: [
        { name: 'Koshi' },
        { name: 'Madhesh Province' },
        { name: 'Bagmati Province' },
        { name: 'Gandaki Province' },
        { name: 'Lumbini Province' },
        { name: 'Karnali Province' },
        { name: 'Sudurpashchim Province' }
      ],
      districtList: [
        // Koshi
        { name: 'Bhojpur', province: 'Koshi' },
        { name: 'Dhankuta', province: 'Koshi' },
        { name: 'Ilam', province: 'Koshi' },
        { name: 'Jhapa', province: 'Koshi' },
        { name: 'Khotang', province: 'Koshi' },
        { name: 'Morang', province: 'Koshi' },
        { name: 'Okhaldhunga', province: 'Koshi' },
        { name: 'Panchthar', province: 'Koshi' },
        { name: 'Sankhuwasabha', province: 'Koshi' },
        { name: 'Solukhumbu', province: 'Koshi' },
        { name: 'Sunsari', province: 'Koshi' },
        { name: 'Taplejung', province: 'Koshi' },
        { name: 'Terhathum', province: 'Koshi' },
        { name: 'Udayapur', province: 'Koshi' },
        // Madhesh Province
        { name: 'Bara', province: 'Madhesh Province' },
        { name: 'Dhanusha', province: 'Madhesh Province' },
        { name: 'Mahottari', province: 'Madhesh Province' },
        { name: 'Parsa', province: 'Madhesh Province' },
        { name: 'Rautahat', province: 'Madhesh Province' },
        { name: 'Saptari', province: 'Madhesh Province' },
        { name: 'Sarlahi', province: 'Madhesh Province' },
        { name: 'Siraha', province: 'Madhesh Province' },
        // Bagmati Province
        { name: 'Bhaktapur', province: 'Bagmati Province' },
        { name: 'Chitwan', province: 'Bagmati Province' },
        { name: 'Dhading', province: 'Bagmati Province' },
        { name: 'Dolakha', province: 'Bagmati Province' },
        { name: 'Kavrepalanchok', province: 'Bagmati Province' },
        { name: 'Kathmandu', province: 'Bagmati Province' },
        { name: 'Lalitpur', province: 'Bagmati Province' },
        { name: 'Makwanpur', province: 'Bagmati Province' },
        { name: 'Nuwakot', province: 'Bagmati Province' },
        { name: 'Ramechhap', province: 'Bagmati Province' },
        { name: 'Rasuwa', province: 'Bagmati Province' },
        { name: 'Sindhuli', province: 'Bagmati Province' },
        { name: 'Sindhupalchok', province: 'Bagmati Province' },
        // Gandaki Province
        { name: 'Baglung', province: 'Gandaki Province' },
        { name: 'Gorkha', province: 'Gandaki Province' },
        { name: 'Kaski', province: 'Gandaki Province' },
        { name: 'Lamjung', province: 'Gandaki Province' },
        { name: 'Manang', province: 'Gandaki Province' },
        { name: 'Mustang', province: 'Gandaki Province' },
        { name: 'Myagdi', province: 'Gandaki Province' },
        { name: 'Nawalpur', province: 'Gandaki Province' },
        { name: 'Parbat', province: 'Gandaki Province' },
        { name: 'Syangja', province: 'Gandaki Province' },
        { name: 'Tanahun', province: 'Gandaki Province' },
        // Lumbini Province
        { name: 'Arghakhanchi', province: 'Lumbini Province' },
        { name: 'Banke', province: 'Lumbini Province' },
        { name: 'Bardiya', province: 'Lumbini Province' },
        { name: 'Dang', province: 'Lumbini Province' },
        { name: 'Gulmi', province: 'Lumbini Province' },
        { name: 'Kapilvastu', province: 'Lumbini Province' },
        { name: 'Nawalparasi', province: 'Lumbini Province' },
        { name: 'Palpa', province: 'Lumbini Province' },
        { name: 'Pyuthan', province: 'Lumbini Province' },
        { name: 'Rolpa', province: 'Lumbini Province' },
        { name: 'Rupandehi', province: 'Lumbini Province' },
        // Karnali Province
        { name: 'Dailekh', province: 'Karnali Province' },
        { name: 'Dolpa', province: 'Karnali Province' },
        { name: 'Humla', province: 'Karnali Province' },
        { name: 'Jajarkot', province: 'Karnali Province' },
        { name: 'Jumla', province: 'Karnali Province' },
        { name: 'Kalikot', province: 'Karnali Province' },
        { name: 'Mugu', province: 'Karnali Province' },
        { name: 'Rukum West', province: 'Karnali Province' },
        { name: 'Salyan', province: 'Karnali Province' },
        { name: 'Surkhet', province: 'Karnali Province' },
        // Sudurpashchim Province
        { name: 'Achham', province: 'Sudurpashchim Province' },
        { name: 'Baitadi', province: 'Sudurpashchim Province' },
        { name: 'Bajhang', province: 'Sudurpashchim Province' },
        { name: 'Bajura', province: 'Sudurpashchim Province' },
        { name: 'Dadeldhura', province: 'Sudurpashchim Province' },
        { name: 'Darchula', province: 'Sudurpashchim Province' },
        { name: 'Doti', province: 'Sudurpashchim Province' },
        { name: 'Kailali', province: 'Sudurpashchim Province' },
        { name: 'Kanchanpur', province: 'Sudurpashchim Province' }
      ],
      filteredDistricts: [],
      allCustomerTypes: [
        { label: 'Hospital/pharmacy', value: 'Hospital/pharmacy' },
        { label: 'Restaurant', value: 'Restaurant' },
        { label: 'New Restaurant', value: 'New Restaurant' },
        {label: 'Oil And Gas', value: 'Oil And Gas'},
        { label: 'Mart', value: 'Mart' },
        { label: 'Khanepani', value: 'Khanepani' },
        { label: 'Suppliers', value: 'Suppliers' },
        { label: 'Cinemas', value: 'Cinemas' },
        { label: 'Other', value: 'Other' }
      ],
      filteredCustomerTypes: [],
      soldFromLists: [
        { label: 'Raise Tech', value: 'Raise Tech' },
        { label: 'Jaks Tech', value: 'Jaks Tech' },
        { label: 'Kripa', value: 'Kripa' },
        { label: 'Others', value: 'Others' }
      ],
      crmCustomerWises: [],
      remarksDialogVisible: false,
      remarksData: {
        remarks: '',
        remarks1: '',
        remarks2: '',
        nextFollowUpDate: null,
        followUpTime: null
      }
    }
  },
  methods: {
    updateDistrictList() {
      if (this.selectedProvince) {
        this.filteredDistricts = this.districtList.filter(district =>
          district.province === this.selectedProvince
        )
        this.selectedDistrict = null
      } else {
        this.filteredDistricts = []
        this.selectedDistrict = null
      }
    },
    async masterSetupLists() {
      await this.$store.dispatch('loadMasterSetupList', 'Crm')
    },
    async loadUserData() {
      await this.$store.dispatch('loadUser')
      const userId = this.$store.state.user.id
      const userData = this.$store.state.users.userLists.find(user => user.id === userId)
      if (userData) {
        this.crmCustomerWises = userData.crmCustomerWises
        this.filteredCustomerTypes = this.getFilteredCustomerTypes(this.crmCustomerWises)
      }
    },
    getFilteredCustomerTypes(userCategories) {
      if (userCategories && userCategories.length > 0) {
        return this.allCustomerTypes.filter(type => userCategories.includes(type.value))
      }
      return this.allCustomerTypes
    },
    searchProducts(event) {
      const query = event.target.value.toLowerCase()
      this.productList = this.originalProductList.filter(product =>
        product.name.toLowerCase().includes(query)
      )
    },
    validateContactNumber() {
      this.contactNumber = this.contactNumber.replace(/\D/g, '')
      if (this.contactNumber.length > 10) {
        this.contactNumber = this.contactNumber.substring(0, 10)
      }
    },
    validateSeconContactNumber() {
      this.secondaryContactNumber = this.secondaryContactNumber.replace(/\D/g, '')
      if (this.secondaryContactNumber.length > 10) {
        this.secondaryContactNumber = this.secondaryContactNumber.substring(0, 10)
      }
    },
    async addFollowUpDetails() {
      if (this.clientName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Client Name cannot be empty', life: 10000})
        return
      }
      if (this.contactNumber === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'contact Number cannot be empty', life: 10000})
        return
      }
      if (this.remarks === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'remarks cannot be empty', life: 10000})
        return
      }
      if (this.customerType === null || this.customerType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'customer Type cannot be empty', life: 10000})
        return
      }
      let resp = ''
      let followUpData = {
        id: this.id,
        clientName: this.clientName,
        contactPerson: this.contactPerson,
        address: this.address,
        contactNumber: this.contactNumber,
        secondaryContactNumber: this.secondaryContactNumber,
        gmail: this.gmail,
        products: this.selectedProducts.map(product => product.name),
        stage: this.selectedStage,
        lastSoldBy: this.soldFrom,
        particular: this.particular,
        rate: this.rate,
        customerType: this.customerType,
        priority: this.priority,
        sampleQuotationSent: this.sampleQuotationSent,
        quotationSent: this.quotationSent,
        callNotReceived: this.callNotReceived,
        commission: this.commission,
        remarks: this.remarks,
        remarks1: this.remarks1,
        remark2: this.remark2,
        nextFollowUpDate: this.nextFollowUpDate,
        nextFollowUpDateNepali: this.nextFollowUpDate,
        followUpTime: this.followUpTime,
        province: this.selectedProvince,
        district: this.selectedDistrict,
        sampleSentDate: this.sampleSentDate,
        sampleDateNepali: this.sampleSentDate,
        quotationUpDate: this.quotationSentDate,
        quotationDateNepali: this.quotationSentDate
      }
      console.log(followUpData)
      if (!this.editing) {
        this.loading = true
        resp = await this.$store.dispatch('createCrmFollowUp', followUpData)
        this.loading = false
      } else {
        this.loading = true
        resp = await this.$store.dispatch('updateCrmFollowUp', followUpData)
        console.log(resp)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async crmProductList() {
      let response = await this.$store.dispatch('loadCrmProductList')
      this.productList = response.data.data
      this.originalProductList = [...this.productList]
    },
    async addAndNewFollowUpDetails() {
      if (this.clientName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Client Name cannot be empty', life: 10000})
        return
      }
      if (this.contactNumber === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'contact Number cannot be empty', life: 10000})
        return
      }
      if (this.remarks === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'remarks cannot be empty', life: 10000})
        return
      }
      if (this.customerType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'customer Type cannot be empty', life: 10000})
        return
      }
      let resp = ''
      let followUpData = {
        clientName: this.clientName,
        contactPerson: this.contactPerson,
        address: this.address,
        contactNumber: this.contactNumber,
        secondaryContactNumber: this.secondaryContactNumber,
        gmail: this.gmail,
        products: this.selectedProducts.map(product => product.name),
        particular: this.particular,
        rate: this.rate,
        customerType: this.customerType,
        priority: this.priority,
        stage: this.selectedStage,
        lastSoldBy: this.soldFrom,
        sampleQuotationSent: this.sampleQuotationSent,
        quotationSent: this.quotationSent,
        callNotReceived: this.callNotReceived,
        commission: this.commission,
        remarks: this.remarks,
        remarks1: this.remarks1,
        remark2: this.remark2,
        nextFollowUpDate: this.nextFollowUpDate,
        nextFollowUpDateNepali: this.nextFollowUpDate,
        followUpTime: this.followUpTime,
        province: this.selectedProvince,
        district: this.selectedDistrict,
        sampleSentDate: this.sampleSentDate,
        sampleDateNepali: this.sampleSentDate,
        quotationUpDate: this.quotationSentDate,
        quotationDateNepali: this.quotationSentDate
      }
      this.loading = true
      resp = await this.$store.dispatch('createCrmFollowUp', followUpData)
      this.loading = false
      this.responseMessage(resp)
      this.reset()
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    checkNepaliDateOrEnglish() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    setNepaliDate() {
      if (this.quotationSentDate === '') {
        this.quotationSentDate = this.$store.getters.nepaliNewDate
      }
      if (this.sampleSentDate === '') {
        this.sampleSentDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#quotationSentDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.quotationSentDate = $('#quotationSentDate').val()
        }
      })
      console.log('this.quotationSentDate' + this.quotationSentDate)
      $('#sampleSentDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.sampleSentDate = $('#sampleSentDate').val()
        }
      })
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
        this.$parent.crmFollowUpList()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    openRemarksDialog() {
      this.remarksData = {
        remarks: this.remarks || '',
        remarks1: this.remarks1 || '',
        remarks2: this.remark2 || '',
        followUpTime: this.followUpTime || null,
        nextFollowUpDate: this.nextFollowUpDate || null,
        clientName: this.clientName + ' Remakrs'
      }
      this.remarksDialogVisible = true
    },
    saveRemarks(data) {
      this.remarks = data.remarks
      this.remarks1 = data.remarks1
      this.remark2 = data.remarks2
      this.followUpTime = data.followUpTime
      this.nextFollowUpDate = data.nextFollowUpDate
      this.remarksDialogVisible = false
    },
    editCrmFollowUp(data) {
      this.id = data.id
      this.editing = true
      // if (data.stage) {
      //   const foundStage = this.stageList.find(item =>
      //     item.value && data.stage &&
      //     item.value.toLowerCase() === data.stage.toLowerCase()
      //   )
      //   this.selectedStage = foundStage ? foundStage.value : null
      // } else {
      //   this.selectedStage = null
      // }
      this.selectedStage = data.stage ? this.stageList.find(item => item.value.toLowerCase() === data.stage.toLowerCase()).value || null : null
      this.clientName = data.clientName
      this.soldFrom = data.lastSoldBy
      this.contactPerson = data.contactPerson
      this.address = data.address
      this.contactNumber = data.contactNumber
      this.secondaryContactNumber = data.secondaryContactNumber
      this.gmail = data.gmail
      this.selectedProducts = data.products.map(productName => {
        return this.productList.find(product => product.name === productName)
      }).filter(product => product !== undefined)
      this.particular = data.particular
      this.rate = data.rate
      this.customerType = data.customerType
      this.priority = data.priority
      this.sampleQuotationSent = data.sampleQuotationSent
      this.quotationSent = data.quotationSent
      this.callNotReceived = data.callNotReceived
      this.commission = data.commission
      this.remarks = data.remarks
      this.remarks1 = data.remarks1
      this.remark2 = data.remark2
      this.followUpTime = data.followUpTime
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nextFollowUpDate = data.nextFollowUpDateNepali
      } else {
        this.nextFollowUpDate = data.nextFollowUpDate
      }
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.sampleSentDate = data.sampleDateNepali
      } else {
        this.sampleSentDate = data.sampleSentDate
      }
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.quotationSentDate = data.quotationDateNepali
      } else {
        this.quotationSentDate = data.quotationSentDate
      }
      this.selectedProvince = data.province
      this.updateDistrictList()
      this.selectedDistrict = data.district
      this.openAddDialog()
    },
    reset() {
      this.clientName = ''
      this.contactPerson = ''
      this.address = ''
      this.contactNumber = ''
      this.secondaryContactNumber = ''
      this.gmail = ''
      this.product = ''
      this.particular = ''
      this.rate = ''
      this.customerType = null
      this.priority = null
      this.sampleQuotationSent = null
      this.quotationSent = null
      this.callNotReceived = false
      this.commission = false
      this.selectedStage = null
      this.lastSoldBy = null
      this.remarks = ''
      this.remarks1 = ''
      this.remark2 = ''
      this.nextFollowUpDate = null
      this.followUpTime = null
      this.selectedProducts = []
      this.selectedProvince = null
      this.selectedDistrict = null
      this.filteredDistricts = []
      this.englishDateEnabled = true
      this.sampleSentDate = ''
      this.quotationSentDate = ''
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.editing = false
      this.closeAddDialog()
    }
  },
  computed: {
    masterSetupList() {
      return this.$store.state.users.masterSetupList
    },
    stageList() {
      return this.masterSetupList.filter(item =>
        item.name === 'stage'
      )
    },
    priorityList() {
      return this.masterSetupList.filter(item =>
        item.name === 'priority'
      )
    }
  },
  mounted() {
    this.masterSetupLists()
    this.crmProductList()
    this.loadUserData()
  },
  components: {
    Dropdown,
    Checkbox,
    Dialogs,
    Toast,
    Button,
    InputText,
    Textarea,
    MultiSelect,
    InputMask,
    RemarksDialog
  }
}
</script>

<style scoped src="@../../../static/css/dialogEntry.css">
.nepali-calendar,
.nepali-calendar * {
    z-index: 999999 !important;
}

#ndp-nepali-box {
    z-index: 999999 !important;
}
</style>



// WEBPACK FOOTER //
// crmFollowUpDetailsDialog.vue?4f1902c6